import { Input, Stack } from "@mui/material";
import React from "react";
import CustomButton from "../CustomButton";

interface CustomColorPickerProps {
  color: string | null;
  defaultColor?: string;
  onChange: (color: string | null) => void;
  justifyContent?: "flex-end" | "space-between" | "flex-start";
  resetButton?: boolean;
}

const CustomColorPicker: React.FC<CustomColorPickerProps> = ({
  color,
  onChange,
  defaultColor,
  resetButton = true,
}: CustomColorPickerProps) => {
  return (
    <Stack
      direction='row'
      spacing={2}
      alignItems='center'
      width={250}
      sx={{
        boxSizing: "border-box",
      }}
    >
      <Input
        disableUnderline
        type='color'
        inputProps={{
          style: {
            width: 150,
            height: 40,
            cursor: "pointer",
            color: "blue",
          },
        }}
        value={color || defaultColor}
        onChange={event => onChange(event.target.value)}
      />
      {resetButton && color && color !== defaultColor && (
        <CustomButton
          onClick={() => onChange(null)}
          title='Reset'
          size='small'
          type='secondary'
          style={{
            width: 100,
          }}
        />
      )}
    </Stack>
  );
};

export default CustomColorPicker;
